import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import axios from '../../../utils/axios';
import { useState } from 'react';
import { MIconButton } from '../../../components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack';
import { Building, DeviceTag } from '../../../@types/model/user';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { LoadingButton } from '@mui/lab';
import { deviceState, getDevices } from 'recoil/deviceState';
import { Device } from '../../../@types/model/device';
import '../../../assets/css/deviceGroupsBuildingsDevices.scss';
import BasicModal from 'components/BasicModal';
import { buildingState, getBuildings } from 'recoil/buildingState';

interface DeviceTagAssignBuildingModalProps {
  deviceTagAssignBuilding: DeviceTag | null;
  buildings: Building[];
  setDeviceTagAssignBuilding: (building: DeviceTag | null) => void;
  setSaving: (saving: Boolean) => void;
}

const DeviceTagAssignBuildingModal = (props: DeviceTagAssignBuildingModalProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const devices: Device[] = useRecoilValue(deviceState);
  const setDevices = useSetRecoilState(deviceState);
  const setBuildings = useSetRecoilState(buildingState);

  const [buildingAssignDeviceTagLoading, setBuildingAssignDeviceTagLoading] =
    useState<boolean>(false);
  const [buildignToAssign, setBuildingToAssign] = useState<Building | null>(null);

  return (
    <BasicModal
      open={props.deviceTagAssignBuilding !== null}
      handleClose={() => {
        setBuildingAssignDeviceTagLoading(false);
        props.setDeviceTagAssignBuilding(null);
        setBuildingToAssign(null);
      }}
    >
      <h2 style={{ marginBottom: '10px' }}>
        {t('assign_building_to')} {props.deviceTagAssignBuilding?.attributes.name}
      </h2>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{t('device')}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={buildignToAssign?.guid ?? ''}
          label={t('building')}
          onChange={(event) => {
            setBuildingToAssign(
              props.buildings.filter((b: Building) => b.guid === event.target.value)[0] ?? null
            );
          }}
        >
          <MenuItem value="">{''}</MenuItem>
          {props.buildings
            .filter((b: Building) => {
              if (b.attributes.parent === props.deviceTagAssignBuilding?.guid) return false;
              return true;
            })
            .map((building: Building) => {
              return (
                <MenuItem key={building.guid} value={building.guid}>
                  {building.attributes.name}
                </MenuItem>
              );
            })}
        </Select>
        <LoadingButton
          fullWidth
          size="small"
          type="submit"
          variant="contained"
          sx={{ my: 2, maxWidth: '180px' }}
          disabled={buildignToAssign === null}
          onClick={() => {
            setBuildingAssignDeviceTagLoading(true);
            if (buildignToAssign && props.deviceTagAssignBuilding) {
              let deviceTagGuid = props.deviceTagAssignBuilding.guid;
              props.setSaving(true);
              axios
                .put(`/api/v2/device-tag/${buildignToAssign?.guid}`, {
                  ...buildignToAssign,
                  attributes: {
                    ...buildignToAssign.attributes,
                    parent: deviceTagGuid
                  }
                })
                .then(() => {
                  enqueueSnackbar(t('building_assigned_to_devicetag'), {
                    variant: 'success',
                    action: (key) => (
                      <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                        <Icon icon={closeFill} />
                      </MIconButton>
                    )
                  });
                  setBuildingAssignDeviceTagLoading(false);
                  props.setDeviceTagAssignBuilding(null);
                  setBuildingToAssign(null);

                  getBuildings().then((buildings: Building[]) => {
                    setBuildings(buildings);
                    props.setSaving(false);
                  });
                })
                .catch(() => {
                  setBuildingAssignDeviceTagLoading(false);
                });
            }
          }}
          loading={buildingAssignDeviceTagLoading}
        >
          {t('assign_building')}
        </LoadingButton>
      </FormControl>
    </BasicModal>
  );
};

export default DeviceTagAssignBuildingModal;
